export * from './decoration-room-position.component';
